import { stytch } from '@/services/stytch/index';
import { useStytchSession } from '@stytch/nextjs';

export const beginUserMasquerade = async ({
    stytchSession,
    stytchSessionJwt,
}: {
    stytchSession: string;
    stytchSessionJwt: string;
}) => {
    // https://stytch.com/docs/sdks/javascript-sdk/resources/cookies-and-session-management#overwriting-the-sdk-managed-session
    document.cookie = `stytch_session=${stytchSession}; path=/;`;
    document.cookie = `stytch_session_jwt=${stytchSessionJwt}; path=/;`;
    localStorage.clear();
    await stytch.session.authenticate();
};

export const useIsMasquerading = () => {
    const { session } = useStytchSession();

    return !!session?.custom_claims?.admin_user_id;
};
